// FOUNDATION
// TODO check if we can import it globally
import $ from 'jquery';
import 'jquery.cookie';
import Rails from "@rails/ujs";
// window.Rails = Rails;

import { RenamePopup } from './rename_popup';

class LoginHandler {
    constructor(event) {
        event.preventDefault();
        this.form = event.target;
    }
    hideErrors() {
        jQuery(".error-tip", this.form).removeClass("show");
    }

    showError(errorElementId) {
        this.hideErrors();
        var errorElement = jQuery(errorElementId, this.form);
        errorElement.show().addClass("show");
        errorElement.siblings("input").addClass("invalid");
    }

    validInput() {
        var username = jQuery('#signin_user_screen_name', this.form).val(),
            password = jQuery('#signin_user_password', this.form).val();

        if (username === '' && password === '') {
            jQuery(this.form).trigger('show-create-account');
        } else if (username === '') {
            this.showError('#wrong-un');
        } else if (password === '') {
            this.showError('#wrong-pw');
        } else {
            return true;
        }
        return false;
    }

    process() {
        if (this.validInput()) {
            const that = this;
            this.loginRequest()
                .fail(function (response) {
                    if (response && response.message) {
                        var errorElement = jQuery("#message", that.form);
                        errorElement.html(errorElement.children()).append(response.message);
                        that.showError('#' + errorElement.attr('id'));
                    }
                });
        }
    }

    enableForm() {
        jQuery("input[type='submit'], button[type='submit']", this.form).removeAttr('disabled');
    }

    disableForm() {
        jQuery("input[type='submit'], button[type='submit']", this.form).attr('disabled', 'disabled');
    }

    loginRequest() {
        let deferredObj = jQuery.Deferred();
        let form = jQuery(this.form);
        const that = this;
        this.disableForm();

        let screenName = form.find("#signin_user_screen_name")
        let csrfToken = $.cookie('XSRF-TOKEN');
        jQuery.ajax({
            url: form.attr('action'),
            type: 'post',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'X-CSRF-Token': csrfToken
            },
            dataType: 'json',
            data: form.serialize()
        }).done(function (response) {
            if (response.message) {
                that.enableForm();
                deferredObj.reject(response, response.message);
                return;
            }
            if (response.good_to_go) {
                deferredObj.resolve();
                window.location = window.location.origin + response.good_to_go;
            } else if (response.redirect_error) {
                deferredObj.resolve();
                window.location = response.redirect_error;
            } else if (response.hasOwnProperty('captcha_challenge')) {
                that.enableForm();
                deferredObj.resolve();
                that.setCaptcha(response.captcha_challenge);
            } else if (response.hasOwnProperty('consent_redeem_reminder')) {
                that.enableForm();
                deferredObj.resolve();

                that.showParentConsent(true);
            } else if (response.hasOwnProperty('rename_action_key')) {
                that.enableForm();
                deferredObj.resolve();

                that.showRenamePopup(screenName.val(), response.rename_action_key);
            } else {
                deferredObj.resolve();
                window.location = "/";
            }
        }).fail(function (err) {
            deferredObj.reject();
            that.enableForm();
        }).always();


        return deferredObj.promise();
    }

    setCaptcha(captcha) {
        captcha = JSON.parse(captcha)
        if (!captcha) {
            ajAlert(jQuery('#translation_message').val())
        } else {
            var challenge = captcha;
            var images = jQuery('.captcha-container .option');
            for (var i = 0; i < 4; i++) {
                jQuery(images[i]).attr('src', challenge.options[i]);
            }
            jQuery('.captcha-container .question').attr('src', challenge.question);
            lastElement = document.activeElement;
						jQuery("#signin_user_screen_name").focus(); // force focus to username chrome workaround
            jQuery('input').blur();
            tabEnabled(false);
            jQuery('.captcha-popup').show();
        }
    }


    showParentConsent() {
        jQuery.get("/parental_consent_reminder?redemption=" + redeem, function (response) {
            jQuery("body").append(response);
        });
    }

    showRenamePopup(screenName, renameActionKey) {
        let form = jQuery("form.rename-account-form");
        let oldScreenName = form.find("#old_screen_name").val();
        form.find("#old_screen_name").val(screenName);
        form.find("#rename_action_key").val(renameActionKey);

        let rejectedMessage;
        if (jQuery("#username_rejected_message").html().search(oldScreenName)) {
            rejectedMessage = jQuery("#username_rejected_message").html().replace(oldScreenName, screenName);
        } else {
            rejectedMessage = jQuery("#username_rejected_message").html().replace("()", "<strong>"+screenName+"</strong>");
        }
        jQuery("#username_rejected_message").html(rejectedMessage)
        new RenamePopup(screenName, renameActionKey).show();
    }
}


export class LoginForm {
    constructor(selector) {
        this.initlialiseSelectors(selector);
        this.attachListeners();
    }

    initlialiseSelectors(selector) {
        this._element = jQuery(selector);
    }

    attachListeners() {
        this._element.on('submit', this.loginHandler);
    }

    loginHandler(event) {
        Rails.stopEverything(event)
        const handler = new LoginHandler(event);
        handler.process();
    }

    static setup(selector) {
        new LoginForm(selector);
    }
}
